import React, { FC, useState } from "react";
import { useTranslation } from "react-i18next";

import { Arrow } from "../../../assets";

const Transaction: FC<TransactionInfo> = ({
  date,
  name,
  qualifiedPoints,
  transactionDate,
  expireDate,
  company,
  transactionsDetails,
  locator,
  voebizPoints,
}) => {
  const { t } = useTranslation("transactions");
  const [isOpen, setIsOpen] = useState(false);

  const toggle = () => setIsOpen(!isOpen);

  const renderTransactionDetails = (transactionsDetailsInfo: any) => {
    return transactionsDetailsInfo.map((details: any) => (
      <>
        <div className="my-transactions__transaction-details">
          <span className="my-transactions__transaction-details-title">{t("transactionDetails")}</span>
          <div className="my-transactions__transaction-grid">
            <div className="my-transactions__transaction-item">
              <span>{t("description")}</span>
              <span>{details.description}</span>
            </div>

            <div className="my-transactions__transaction-item">
              <span>{t("traveler")}</span>
              <span>{details.traveler}</span>
            </div>

            <div className="my-transactions__transaction-item">
              <span>{t("id")}</span>
              <span>{details.id}</span>
            </div>

            <div className="my-transactions__transaction-item">
              <span>{t("locator")}</span>
              <span>{details.locator}</span>
            </div>

            <div className="my-transactions__transaction-item">
              <span>{t("voebizPoints")}</span>
              <span>{Intl.NumberFormat("pt-BR").format(Number(details.voebizPoints))}</span>
            </div>

            <div className="my-transactions__transaction-item">
              <span>{t("status")}</span>
              <span>{details.status}</span>
            </div>
          </div>
        </div>
      </>
    ));
  };

  return (
    <div className="my-transactions__transaction" aria-expanded={isOpen} data-testid="transaction">
      <div className="my-transactions__transaction-top">
        <div>
          <div className="my-transactions__transaction-item">
            <span>{t("date")}</span>
            <span>{date}</span>
          </div>

          <div className="my-transactions__transaction-top--name my-transactions__transaction-item">
            <span>{t("description")}</span>
            <span>{name}</span>
          </div>
        </div>

        <div className="my-transactions__transaction-item">
          <span>{t("qualifiedPoints")}</span>
          <span>{Intl.NumberFormat("pt-BR").format(Number(qualifiedPoints))}</span>
        </div>

        <div className="my-transactions__transaction-item my-transactions__transaction-item--points">
          <span>{t("redeemedPoints")}</span>
          {voebizPoints >= 0 ? (
            <span> + {Intl.NumberFormat("pt-BR").format(Number(voebizPoints))}</span>
          ) : (
            <span> {Intl.NumberFormat("pt-BR").format(Number(voebizPoints))}</span>
          )}
        </div>

        <button className="my-transactions__transaction-btn" type="button" onClick={toggle} aria-label="Expandir">
          <img src={Arrow} alt="Seta" />
        </button>
      </div>

      {isOpen && (
        <div className="my-transactions__transaction-content">
          <div className="my-transactions__transaction-grid">
            <div className="my-transactions__transaction-item">
              <span>{t("transactionDate")}</span>
              <span>{transactionDate}</span>
            </div>

            <div className="my-transactions__transaction-item">
              <span>{t("locator")}</span>
              <span>{locator}</span>
            </div>

            <div className="my-transactions__transaction-item">
              <span>{t("expireDate")}</span>
              <span>{expireDate}</span>
            </div>

            <div className="my-transactions__transaction-item">
              <span>{t("company")}</span>
              <span>{company}</span>
            </div>
          </div>
          {renderTransactionDetails(transactionsDetails)}
        </div>
      )}
    </div>
  );
};

export default Transaction;
